import gql from 'graphql-tag';

export const updateOpAlertLogEntry = gql`
  mutation updateOpAlertLogEntry($input: OpAlertLogEntryInput) {
    updateOpAlertLogEntry(input: $input) {
      id
      opAlertLogId
      time
      user
      entry
      createdBy
      createdAt
      updatedAt
      version
    }
  }
`;
